import { Link } from "@mui/material";

export const MailToCell = ({ email }: { email: string | undefined }) =>
  email ? (
    <Link href={`mailto:${email}`} rel="noopener noreferrer" target="_top">
      {email}
    </Link>
  ) : (
    <div>-</div>
  );
